/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sunny_Fuzzy_Termite_GreetInputs */

const fr_sunny_fuzzy_termite_greet = /** @type {(inputs: Sunny_Fuzzy_Termite_GreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique la charge ainsi que le poids de la barre de base et on se charge du reste`)
};

/**

* @param {Sunny_Fuzzy_Termite_GreetInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sunny_fuzzy_termite_greet = /** @type {((inputs?: Sunny_Fuzzy_Termite_GreetInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sunny_Fuzzy_Termite_GreetInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sunny_fuzzy_termite_greet(inputs)
});